import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subject, pairwise, take } from 'rxjs';
import { ApiService } from '@shared/services/api.service';
import { CategoriesService } from '@shared/services/categories.service';
import { LocaleService } from '@shared/services/locale.service';
import { SnackService } from '@shared/services/snack.service';
import { ViewportService } from '@shared/services/viewport.service';
import { ScrollService } from '@shared/services/scroll.service';
@Component({
	selector: 'app-filter',
	templateUrl: './filter.component.html',
	styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private categoriesService: CategoriesService,
		private snack: SnackService,
		private api: ApiService,
		public locale: LocaleService,
		public viewport: ViewportService,
		private scroll: ScrollService
	) {}

	@ViewChild('datepicker') datepicker: any;
	@Input() isFilterReset: any;
	@Input() sortBy: string;

	filtered: boolean = false;
	catID: string;
	subCatID: string;
	subcategories = [];
	locations = [];
	popularLocations = [];
	motorData = {};
	models = [];
	brands = [];
	step = -1;
	selectedDate: string;
	electronicData = {};
	priceFilterData = [];
	minPrice = ['0', '5,000', '10,000', '20,000', '30,000', '40,000', '50,000', '75,000', '100,000'];
	maxPrice = ['5,000', '10,000', '20,000', '30,000', '40,000', '50,000', '75,000', '100,000', '500,000'];
	latestValue = 0;
	form: UntypedFormGroup = new UntypedFormGroup({
		subCatID: new UntypedFormControl(null),
		location: new UntypedFormControl(null),
		makeID: new UntypedFormControl(null),
		modelID: new UntypedFormControl(null),
		year: new UntypedFormControl(null),
		colorID: new UntypedFormControl(null),
		order: new UntypedFormControl(null),
		date: new UntypedFormControl(null),
		electronicBrandID: new UntypedFormControl(null),
		electronicModelID: new UntypedFormControl(null),
		electronicColorID: new UntypedFormControl(null),
		electronicStorageID: new UntypedFormControl(null),
		electronicMemoryID: new UntypedFormControl(null),
		electronicProcessorID: new UntypedFormControl(null),
		electronicGraphicsID: new UntypedFormControl(null),
		electronicNetworkID: new UntypedFormControl(null),
		minPrice: new UntypedFormControl(null),
		maxPrice: new UntypedFormControl(null),
	});

	searchTextSubCat = new UntypedFormControl('');
	searchTextBrand = new UntypedFormControl('');
	searchTextModel = new UntypedFormControl('');
	searchTextLocation = new UntypedFormControl('');
	searchTextMake = new UntypedFormControl('');
	searchTextYear = new UntypedFormControl('');
	searchTextColor = new UntypedFormControl('');
	searchTextStorage = new UntypedFormControl('');
	searchTextMemory = new UntypedFormControl('');
	searchTextMinPrice = new UntypedFormControl('');
	searchTextMaxPrice = new UntypedFormControl('');
	searchTextProcessor = new UntypedFormControl('');
	searchTextGraphics = new UntypedFormControl('');
	searchTextNetwork = new UntypedFormControl('');
	hasSelection: boolean = false;

	// onClearSearch(searchTextControl: UntypedFormControl, select?: MatSelect) {
	// 	//for brand and make we are reseting searchTextBrand and searchTextModel from brandSelection(),makeSelection() function
	// 	setTimeout(() => {
	// 		searchTextControl?.setValue('');
	// 	});
	// }

	// setStep(index: number) {
	// 	if (Object.values(this.form.controls).some((control) => control.value)) {
	// 		this.hasSelection = true;
	// 	}
	// 	this.step = index;
	// }

	// nextStep() {
	// 	this.step++;
	// }

	// prevStep() {
	// 	this.step--;
	// }
	// openColorDropdown(select: MatSelect) {
	// 	select.open(); // Programmatically open the dropdown
	// }

	// onSubcategorySelection(event) {
	// 	this.hasSelection = true;
	// 	if (event['value'] === '291') {
	// 		this.form.get('makeID').reset();
	// 		this.form.get('modelID').reset();
	// 		this.form.get('year').reset();
	// 		this.form.get('colorID').reset();
	// 	} else if (
	// 		event['value'] === '302' ||
	// 		event['value'] === '303' ||
	// 		event['value'] === '304' ||
	// 		event['value'] === '305' ||
	// 		event['value'] === '306' ||
	// 		event['value'] === '307' ||
	// 		event['value'] === '308' ||
	// 		event['value'] === '309' ||
	// 		event['value'] === '310' ||
	// 		event['value'] === '311' ||
	// 		event['value'] === '312' ||
	// 		event['value'] === '313' ||
	// 		event['value'] === '365' ||
	// 		event['value'] === '366' ||
	// 		event['value'] === '367' ||
	// 		event['value'] === '370' ||
	// 		event['value'] === '371' ||
	// 		event['value'] === '372' ||
	// 		event['value'] === '373'
	// 	) {
	// 		this.form?.get('electronicBrandID')?.reset();
	// 		this.form?.get('electronicModelID')?.reset();
	// 		this.form?.get('electronicColorID')?.reset();
	// 		this.form?.get('electronicStorageID')?.reset();
	// 		this.form?.get('electronicMemoryID')?.reset();
	// 		this.form?.get('electronicProcessorID')?.reset();
	// 		this.form?.get('electronicGraphicsID')?.reset();
	// 		this.form?.get('electronicNetworkID')?.reset();
	// 	}
	// }

	// onMakeSelection(makeID: string, modelID: string = undefined) {
	// 	this.hasSelection = true;

	// 	let formData: FormData = new FormData();
	// 	this.form.get('modelID').reset();
	// 	this.searchTextMake.reset();
	// 	this.models = [];

	// 	if (makeID) {
	// 		formData.append('makeID', makeID);
	// 		formData.append('lang', this.locale.lang);

	// 		this.api.models(formData).subscribe((res) => {
	// 			if (res['status'] === '1') {
	// 				this.models = res['response'];
	// 				this.form.get('modelID').setValue(modelID);
	// 			} else {
	// 				this.snack.open(this.locale.translations['ads']['filter']['s2']);
	// 			}
	// 		});
	// 	}
	// }
	// onBrandSelection(electronicBrandID: string, electronicModelID: string = undefined) {
	// 	this.hasSelection = true;

	// 	let formData: FormData = new FormData();
	// 	this.form.get('electronicModelID').reset();

	// 	this.models = [];
	// 	if (electronicBrandID) {
	// 		formData.append('brandID', electronicBrandID);
	// 		formData.append('electronicBrandID', electronicBrandID);
	// 		formData.append('subCatID', this.form.get('subCatID').value);
	// 		formData.append('lang', this.locale.lang);
	// 	}
	// 	this.api.electronicModels(formData).subscribe((res) => {
	// 		if (res['status'] === '1') {
	// 			this.models = res['response'];
	// 			this.form.get('electronicModelID').setValue(electronicModelID);
	// 		} else {
	// 			this.snack.open(this.locale.translations['ads']['filter']['s2']);
	// 		}
	// 	});
	// }
	// onDateSelection($date) {
	// 	this.hasSelection = true;

	// 	let date = new Date($date),
	// 		month = '' + (date.getMonth() + 1),
	// 		day = '' + date.getDate(),
	// 		year = date.getFullYear();

	// 	if (month.length < 2) month = '0' + month;
	// 	if (day.length < 2) day = '0' + day;

	// 	const formattedDate: string = [day, month, year].join('-');
	// 	this.selectedDate = formattedDate.replace(new RegExp('-', 'g'), '/');
	// 	this.form.get('date').setValue(formattedDate);
	// 	this.datepicker.close();
	// }

	// //On price range selection ,NOT using here
	// onPriceSelection() {
	// 	let maxPrice = parseInt(this.form.get('maxPrice').value);
	// 	if (maxPrice && maxPrice <= parseInt(this.form.get('minPrice').value)) {
	// 		this.form.get('minPrice').setValue(this.priceFilterData['min'][0]);
	// 		this.snack.open(this.locale.translations['ads']['filter']['n434']);
	// 	}
	// }

	// // using here
	// onFilterSelected() {
	// 	this.hasSelection = true;
	// }

	// valuChangeEvent(event: number) {
	// 	let f: any;
	// 	if (event === 0) {
	// 		f = this.form.get('minPrice');
	// 	} else if (event === 1) {
	// 		f = this.form.get('maxPrice');
	// 	}
	// 	f.valueChanges.pipe(pairwise(), take(1)).subscribe(([old, value]) => {
	// 		if (value > this.form.get('maxPrice').value) {
	// 			this.form.get('minPrice').setValue(old);
	// 		}
	// 		this.latestValue = value;
	// 	});
	// }

	// onSubmit() {
	// 	this.nextStep();

	// 	this.scroll.saveAdListPageNo(undefined);

	// 	// apply
	// 	this.router.navigate([], {
	// 		relativeTo: this.route,
	// 		queryParams: this.form['value'],
	// 	});
	// }

	// clear() {
	// 	// clear
	// 	this.scroll.saveAdListPageNo(undefined);

	// 	this.router.navigate([], {
	// 		relativeTo: this.route,
	// 	});
	// 	this.form.reset();
	// }

	// autoFocus() {
	// 	const searchbox = document.getElementById('searchbox');
	// 	if (searchbox) {
	// 		searchbox.focus();
	// 	}
	// }

	ngOnInit(): void {
		// 	// subcategories
		// 	this.route.params.subscribe((params: Params) => {
		// 		if (params['category']) {
		// 			this.catID = params['category'];
		// 			let catFormData: FormData = new FormData();
		// 			catFormData.append('lang', this.locale.lang);
		// 			catFormData.append('catID', params['category']);
		// 			this.api.categories(catFormData).subscribe((res) => {
		// 				this.subcategories = this.categoriesService.strip(res['response'][0]['subCategories']);
		// 			});
		// 		}
		// 	});
		// 	// locations
		// 	let locFormData: FormData = new FormData();
		// 	locFormData.append('lang', this.locale.lang);
		// 	this.api.locations(locFormData).subscribe((res) => {
		// 		if (res['status'] === '1') {
		// 			this.locations = res['response'];
		// 			this.locations.forEach((location) => {
		// 				if (location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89') {
		// 					this.popularLocations.push(location);
		// 				}
		// 			});
		// 			this.locations = this.locations.filter((location) => {
		// 				return !(location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89');
		// 			});
		// 		} else {
		// 			this.snack.open(this.locale.translations['ads']['filter']['s3']);
		// 		}
		// 	});
		// 	// motor data
		// 	let motorFormData: FormData = new FormData();
		// 	motorFormData.append('lang', this.locale.lang);
		// 	this.api.motorData(motorFormData).subscribe((res) => {
		// 		if (res['status'] === '1') {
		// 			this.motorData = res['response'];
		// 		} else {
		// 			this.snack.open(this.locale.translations['ads']['filter']['s4']);
		// 		}
		// 	});
		// 	//electronic data[Done Right]
		// 	let electronicFormData: FormData = new FormData();
		// 	electronicFormData.append('lang', this.locale.lang);
		// 	this.api.electronicFilterData(electronicFormData).subscribe((res) => {
		// 		if (res['status'] === '1') {
		// 			this.electronicData = res['response'];
		// 		} else {
		// 			this.snack.open(this.locale.translations['ads']['filter']['s4']);
		// 		}
		// 	});
		// 	//get price filter data
		// 	let priceFormData: FormData = new FormData();
		// 	priceFormData.append('lang', this.locale.lang);
		// 	this.api.priceFilterData(priceFormData).subscribe((res) => {
		// 		if (res['status'] === '1') {
		// 			this.priceFilterData = res['response'];
		// 		} else {
		// 			this.snack.open(this.locale.translations['ads']['filter']['s4']);
		// 		}
		// 	});
		// 	// route query params
		// 	this.route.queryParams.subscribe((queries: Params) => {
		// 		this.form.get('subCatID').setValue(queries['subCatID']);
		// 		this.form.get('location').setValue(queries['location']);
		// 		this.form.get('makeID').setValue(queries['makeID']);
		// 		this.form.get('year').setValue(queries['year']);
		// 		this.form.get('colorID').setValue(queries['colorID']);
		// 		this.form.get('modelID').setValue(queries['modelID']);
		// 		this.form.get('electronicBrandID').setValue(queries['electronicBrandID']);
		// 		this.form.get('electronicModelID').setValue(queries['electronicModelID']);
		// 		this.form.get('electronicColorID').setValue(queries['electronicColorID']);
		// 		this.form.get('electronicStorageID').setValue(queries['electronicStorageID']);
		// 		this.form.get('electronicMemoryID').setValue(queries['electronicMemoryID']);
		// 		this.form.get('electronicProcessorID').setValue(queries['electronicProcessorID']);
		// 		this.form.get('electronicGraphicsID').setValue(queries['electronicGraphicsID']);
		// 		this.form.get('electronicNetworkID').setValue(queries['electronicNetworkID']);
		// 		this.form.get('minPrice').setValue(+queries['minPrice'] ? +queries['minPrice'] : null);
		// 		this.form.get('maxPrice').setValue(+queries['maxPrice'] ? +queries['maxPrice'] : null);
		// 		this.form.get('order').setValue(queries['order']);
		// 		this.form.get('date').setValue(queries['date'] ? queries['date'] : null);
		// 		if (queries['date']) {
		// 			this.selectedDate = queries['date'].replace(new RegExp('-', 'g'), '/');
		// 		}
		// 		if (queries['makeID']) {
		// 			this.onMakeSelection(queries['makeID'], queries['modelID']);
		// 		}
		// 		if (queries['electronicBrandID']) {
		// 			this.onBrandSelection(queries['electronicBrandID'], queries['electronicModelID']);
		// 		}
		// 		if (Object.keys(queries).length > 0) {
		// 			this.filtered = true;
		// 		}
		// 		this.subCatID = queries['subCatID'];
		// 	});
	}
}
